export function Footer() {
  return (
    <div className="footer-links">
      <span>&copy; 2026 Nuthatch LLC</span>
      <span className="footer-dot">&middot;</span>
      <a href="https://nuthatchllc.com" target="_blank" rel="noopener noreferrer">
        nuthatchllc.com
      </a>
      <span className="footer-dot">&middot;</span>
      <a href="/blog">Blog</a>
    </div>
  );
}
